// Shipping Bar (snippets/cart-free-shipping-bar.liquid): animiert vom letzten Stand zum neuen.
// Der Warenkorb-Drawer wird nach jeder Aenderung neu gerendert, daher merkt sich window.__suShipBar den letzten
// Fortschritt und Zustand. Laeuft die Aenderung bei geschlossenem Drawer, wird die Animation beim Oeffnen gespielt.
(() => {
  if (customElements.get('su-shipping-bar')) return;
  const state = (window.__suShipBar = window.__suShipBar || { progress: null, success: false, text: null });
  const drawerOpen = () => document.body.classList.contains('page-overlay-cart-on') || !document.querySelector('cart-drawer');
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  customElements.define('su-shipping-bar', class extends HTMLElement {
    connectedCallback() {
      this.fill = this.querySelector('.su-ship__fill');
      this.progressText = this.querySelector('.su-ship__text--progress');
      this.renderedText = this.progressText ? this.progressText.innerHTML : '';
      this.target = Number(this.dataset.progress || 0);
      this.success = this.dataset.success === 'true';
      this.count = Number(this.dataset.count || 0);
      // Glow bei Erfolg, wenn gerade etwas hinzugekommen ist (auch wenn der Versand schon vorher frei war)
      this.added = state.count !== undefined && this.count > state.count;
      if (!this.fill || reduce) return this.remember();
      // Warenkorbseite (Zusammenfassung, sections/main-cart-footer.liquid): Endzustand ohne Animation
      if (this.closest('.su-cartsum')) {
        this.classList.toggle('is-success', this.success);
        this.fill.style.width = this.target + '%';
        return this.remember();
      }
      const from = state.progress === null ? 0 : state.progress;
      const wasSuccess = state.success;
      // Startzustand ohne Transition setzen
      this.fill.style.transition = 'none';
      this.fill.style.width = from + '%';
      this.classList.toggle('is-success', wasSuccess && this.success);
      // Beim Hochlaufen in den Erfolg den alten Fortschrittstext stehen lassen, bis der Balken voll ist
      if (this.success && !wasSuccess && state.text && this.progressText) this.progressText.innerHTML = state.text;
      if (!this.success && wasSuccess) this.classList.add('is-success');
      void this.fill.offsetWidth;
      this.fill.style.transition = '';
      this.pending = true;
      if (drawerOpen()) this.play(from, wasSuccess, this.success && this.added);
      else {
        // Drawer zu (z. B. Hinzufuegen von der Produktseite): Zustand gilt sofort, der Balken laeuft beim Oeffnen von 0 hoch.
        // Der gemerkte Zustand darf hier keine Rolle spielen, sonst bleibt ein alter Erfolg stehen.
        this.classList.toggle('is-success', this.success);
        if (this.progressText && this.renderedText) this.progressText.innerHTML = this.renderedText;
        // Erstmals kostenlos (z. B. Markt mit Schwelle 0): beim Oeffnen zusaetzlich der Lichtschweif
        const celebrate = this.success && (!wasSuccess || this.added);
        document.addEventListener('su:drawer-open', () => this.isConnected && this.pending && this.play(0, this.success, celebrate), { once: true });
      }
      this.remember();
    }
    disconnectedCallback() {
      // Ohne Leiste im Drawer (leerer Warenkorb) den gemerkten Stand verwerfen, damit das naechste Hinzufuegen bei 0 beginnt
      queueMicrotask(() => {
        if (!document.querySelector('su-shipping-bar')) Object.assign(state, { progress: null, success: false, text: null });
      });
    }
    play(from, wasSuccess, celebrate = false) {
      this.pending = false;
      if (from !== state.progress) { this.fill.style.transition = 'none'; this.fill.style.width = from + '%'; void this.fill.offsetWidth; this.fill.style.transition = ''; }
      requestAnimationFrame(() => {
        if (!this.success) this.classList.remove('is-success');
        this.fill.style.width = this.target + '%';
        if (!this.success && this.target !== from) { this.classList.remove('is-bump'); void this.offsetWidth; this.classList.add('is-bump'); }
        if ((this.success && !wasSuccess) || celebrate) {
          // Laeuft der Balken noch, erst danach; ist er schon voll, sofort
          const wait = this.target !== from ? 650 : 150;
          setTimeout(() => { this.classList.add('is-success', 'is-celebrating'); }, wait);
          setTimeout(() => this.classList.remove('is-celebrating'), wait + 1900);
        }
      });
    }
    remember() {
      state.progress = this.target;
      state.success = this.success;
      state.count = this.count;
      if (!this.success && this.progressText) state.text = this.progressText.innerHTML;
    }
  });

  // Drawer-Oeffnen erkennen (Klasse am Body), damit eine im Hintergrund vorbereitete Animation sichtbar laeuft
  new MutationObserver(() => {
    const open = document.body.classList.contains('page-overlay-cart-on');
    if (open && !window.__suShipWasOpen) document.dispatchEvent(new CustomEvent('su:drawer-open'));
    window.__suShipWasOpen = open;
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
